import { Checkbox, FormControlLabel, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { Bell, Edit2, MoreVertical, Trash2, X } from "react-feather";
import styles from "./FollowUpList.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useState } from "react";

const FollowUpList = ({ setFollowUpList, followUpList, setFollowUpEditData, setLoading, setSnackbarMsg, setSnackbarOpen, setOpenFollowUpModal }) => {
  const [selectecId, setSelectecId] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(0);
  const { getAccessTokenSilently } = useAuth0();
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const confirmDelete = async () => {
    setDeleteModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(process.env.REACT_APP_APPLICANT_API_URL + "v1/follow-ups/" + selectecId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
      setLoading(false);

      setFollowUpList((prev) => {
        return prev?.filter((i) => i?.id !== selectecId);
      });
      setSelectecId(0);
    }).catch((error) => {
      if (typeof error.response !== "undefined") {
        setSnackbarOpen(true);
        setSnackbarMsg(error.response.data.message);
        setLoading(false);
      }
    });
  }

  const handleCheckboxChange = async (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    const updatedStatus = !item.is_completed;
    const completedDate = updatedStatus ? moment().format("YYYY-MM-DD") : null;
    const data = { is_completed: updatedStatus, completed_date: completedDate };

    axios.put(process.env.REACT_APP_APPLICANT_API_URL + "v1/follow-ups/" + item.id, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
      setLoading(false);

      setFollowUpList((prev) => {
        return prev?.map((l) => {
          if (l.id === item?.id) return response.data.data;
          return l;
        });
      });
      setSelectecId(0);
    }).catch((error) => {
      if (typeof error.response !== "undefined") {
        setSnackbarOpen(true);
        setSnackbarMsg(error.response.data.message);
        setLoading(false);
      }
    });
  }

  return (<div className={`${styles.TaskTabCardAccoRow}`}>
    {followUpList?.length > 0 && followUpList.map((item, i) => {
      return (<div onClick={(e) => { setFollowUpEditData(item); }} className={`${styles.TaskTabTourList} ${styles.FollowUp}`} key={item?.id}>
        <div className={`${styles.TourNameSec} ${styles.FollowUp}`}>
          <FormControlLabel
            className={`${styles.ProsCheckSec}`}
            control={
              <Checkbox
                checked={!!item?.is_completed}
                onClick={(e) => {
                  e.stopPropagation(); // Stop row click, but don't prevent default
                }}
                onChange={(e) => {
                  e.stopPropagation();
                  handleCheckboxChange(e, item);
                }}
              />
            }
          />
          <div>
            <p class={`${styles.TourCretorName}`}>{item?.description}</p>
            <p class={`${styles.TourCretorDate}`}><Bell /> {moment(item?.date).format("MM/DD/YYYY")}</p>
          </div>
        </div>
        <div className={openDropdownId === item.id ? `${styles.TaskTabTourListActionSec} ${styles.FollowUp} ${styles.Active}` : `${styles.TaskTabTourListActionSec} ${styles.FollowUp}`}>
          <Dropdown
            className={`${styles.ProEditSec} ${styles.Table}`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            show={openDropdownId === item.id}
            onToggle={(isOpen, event, metadata) => {
              if (isOpen) {
                setOpenDropdownId(item.id);
              } else {
                setOpenDropdownId(null);
              }
            }}
          >
            <Dropdown.Toggle className={`${styles.EditActionsBU} ${styles.Table} ProsDrBU`} id={`dropdown-${item.id}`}><MoreVertical /></Dropdown.Toggle>

            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
              <Dropdown.Item onClick={(e) => { setFollowUpEditData(item); setOpenDropdownId(null); }} className={`${styles.EditActionsBUListItem}`}>
                <Edit2 /> Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteModalOpen(true); setSelectecId(item.id); setOpenDropdownId(null); }} className={`${styles.EditActionsBUListItem} ${styles.Delete}`}>
                <Trash2 /> Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>);
    })}

    {followUpList?.length === 0 && (<div className={`${styles.NotesRow}`}>
      <div className={`${styles.NoDataMain}`}>
        <div className={`${styles.NoDataIMG}`}>
          <img src="/static/img/no-follow-up.png" alt="" />
        </div>
        <p className={`${styles.NoDataText}`}>Woohoo!</p>
        <p className={`${styles.NoDataTextSub}`}>Follow-up list is all caught up.</p>
        <button className={`${styles.AddLeaseBU}`} onClick={(e) => { setOpenFollowUpModal(true); }}>
          <Bell /> Set Follow-Up
        </button>
      </div>
    </div>)}

    <Dialog
      open={deleteModalOpen}
      onClose={(e) => setDeleteModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Would you like to delete this follow-Up?
        <button onClick={(e) => setDeleteModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The follow-up information will be removed immediately.You can'tnundo this action.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>
  </div>);
};

export default FollowUpList;